import { seatingDataValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { partialOccSeatingConfigValidator } from '../../../context/occ/types/config/seating/seating';
import { defaultSeatPickerDisplayText, seatPickerDisplayTextValidator } from './display-text';
import { seatPickerEventsValidator } from './events';
import { defaultSeatPickerSubcomponents, seatPickerSubcomponentsValidator } from './subcomponents';
export const seatPickerPropsValidator = Validator.object({
    data: seatingDataValidator,
    selectedSeatIds: Validator.array({ items: Validator.nonEmptyString }),
    events: seatPickerEventsValidator,
    config: partialOccSeatingConfigValidator,
    displayText: seatPickerDisplayTextValidator,
    isDisabled: Validator.optional(Validator.boolean()),
    subcomponents: seatPickerSubcomponentsValidator
});
export const defaultSeatPickerProps = {
    data: undefined,
    selectedSeatIds: [],
    events: {},
    config: {},
    displayText: defaultSeatPickerDisplayText,
    subcomponents: defaultSeatPickerSubcomponents
};
//# sourceMappingURL=props.js.map